import PropTypes from 'prop-types';
import {useEffect, useState, useMemo, useCallback} from 'react';
import {Helmet} from 'react-helmet';
import {debounce} from 'throttle-debounce';
import ScheduleList from 'Schedule/components/ScheduleList';
import ScheduleLobbyActionToolbar from 'Schedule/components/ScheduleLobbyActionToolbar';
import {findAllSchedules} from 'Schedule/service/ScheduleService';

export default function ScheduleLobby(props, context) {
  const {router} = context;
  const {
    location: {query, pathname},
  } = props;
  const [schedules, setSchedules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const numSchedules = useMemo(() => schedules.length, [schedules]);
  const handleEditSchedule = ({id}) => {
    router.push(`Schedules/${id}/update`);
  };
  const handleViewSchedule = ({id}) => {
    router.push(`Schedules/${id}/scheduleSteps`);
  };
  const {scheduleTitleFilterText = '', scheduleTeamFilterText = ''} = query;
  const decodedScheduleTitleFilterText = decodeURIComponent(
    scheduleTitleFilterText,
  );
  const decodedScheduleTeamFilterText = decodeURIComponent(
    scheduleTeamFilterText,
  );
  const handleChangeScheduleTitleFilter = debounce(1000, (titleFilterText) => {
    router.replace({
      pathname,
      query: {
        scheduleTitleFilterText:
          encodeURIComponent(titleFilterText) || undefined,
        scheduleTeamFilterText: scheduleTeamFilterText || undefined,
      },
    });
  });
  const handleChangeScheduleTeamFilter = useCallback(
    (teamFilterText) => {
      router.replace({
        pathname,
        query: {
          scheduleTitleFilterText: scheduleTitleFilterText || undefined,
          scheduleTeamFilterText:
            encodeURIComponent(teamFilterText) || undefined,
        },
      });
    },
    [pathname, scheduleTitleFilterText, router],
  );

  useEffect(() => {
    if (isLoading) {
      const handleRetrieveSchedules = async () => {
        setSchedules(await findAllSchedules());
      };

      handleRetrieveSchedules();
      setIsLoading(false);
    }
  }, [isLoading]);

  return (
    !isLoading && (
      <>
        <Helmet title="Schedules" defer={false} />
        <ScheduleLobbyActionToolbar numSchedules={numSchedules} />
        <ScheduleList
          schedules={schedules}
          onEditSchedule={handleEditSchedule}
          onViewSchedule={handleViewSchedule}
          scheduleTitleFilter={decodedScheduleTitleFilterText}
          scheduleTeamFilter={decodedScheduleTeamFilterText}
          onChangeScheduleTitleFilter={handleChangeScheduleTitleFilter}
          onChangeScheduleTeamFilter={handleChangeScheduleTeamFilter}
        />
      </>
    )
  );
}

ScheduleLobby.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({
      scheduleTitleFilterText: PropTypes.string,
      scheduleTeamFilterText: PropTypes.string,
    }),
  }).isRequired,
};
ScheduleLobby.contextTypes = {
  router: PropTypes.object,
};
